import { useState, useEffect } from 'react'
import { Link } from "react-router-dom"
import { Cargando, Confirm, Error, I, LinkBtn, Recycle } from '../shared';
import { getRecibo } from './handlers';
import printIframe from '../utils/printIframe';
import { TIME_PRINT, TIME_PRINT_CONFIRM } from '../utils/const';
import { QRCodeSVG } from 'qrcode.react';
import { Modal } from 'react-bootstrap';

export const MostrarRecibo = ({
  location: {
    state: { numero_acta },
  },
}) => {
  const [recibo, setRecibo] = useState(null);
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)
  const [print, setPrint] = useState(null)
  const [file, setFile] = useState(null)
  const [qrLink, setQrLink] = useState(null)
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    getRecibo(numero_acta, setRecibo, setFile, setQrLink, setIsLoading, setError)
  }, [numero_acta])

  const printModal = () => {
    printIframe('pdf');

    setTimeout(() => setPrint('imprimiendo'), TIME_PRINT);

    setTimeout(() => setPrint('confirmacion'), TIME_PRINT_CONFIRM);
  };

  if (print === 'imprimiendo') return <Cargando str={'Aguarde mientra se imprime su recibo'} />;

  if (print === 'confirmacion')
    return (
      <Confirm
        msg={'¿Se logro imprimir?'}
        setPrint={setPrint}
      />
    );

  const printQr = () => {
    if (qrLink === null)
      return (
        <div className="d-inline-flex">
          <Recycle /> <span style={{ margin: 'auto' }}>Cargando QR...</span>
        </div>
      );

    if (qrLink === -1)
      return (
        <div className="d-inline-flex">
          <Recycle /> <span style={{ margin: 'auto' }}>No se logro cargar el QR</span>
        </div>
      );

    return (
      <div className="d-inline-flex">
        <Recycle />{' '}
        <span style={{ margin: 'auto' }}>Para pagar online escanea el código QR</span>
      </div>
    );
  };

  const showQrModal = () => {
    if (qrLink !== -1 && qrLink !== null) setModalShow(true);
  };

  return (
    <div className="container">
      <div className="row mt-3">
        {isLoading ? <Cargando /> : recibo ? (
          <>
            {recibo && (
              <div className="col-md-8">
                <iframe src={recibo.recibo.urlRecibo} height="580px" width="100%" id="pdf" title={'PDF Recibo'}></iframe>
              </div>
            )}
            {/* {file && (
              <a href={URL.createObjectURL(file)} download="file.pdf">
                DESCARGAR
              </a>
            )} */}
            <div className="col-md-4">
              <div className="card background-main-div text-center">
                <div className="card-header titulo-componente text-center">
                  <span className="card-title font-weight-bold text-white">RECIBO</span>
                </div>
                <div className="card-body text-center">Se generó el recibo de su acta, ¿Desea enviarlo por email o imprimirlo?</div>
                <div className="card-body text-center recycle">
                  <div
                    onClick={() => showQrModal()}
                    className="card-body text-center recycle"
                  >
                    {printQr()}
                  </div>
                </div>
                <div className="card-footer">
                  <div className="btn-wrapper">
                    <button onClick={() => printModal()} type="button" className="btn btn-info active m-3">
                      <I classname="fa fa-print" /> IMPRIMIR
                    </button>
                    {/* <Link
                      to={{
                        pathname: '/apps/inmueble/mail/',
                        // state: { data: emision.data, periodo: 'Semestral', tipo },
                      }}
                      className="btn btn-success mb-1 float-right"
                    >
                      <I classname="fa fa-envelope-o" /> ENVIAR POR EMAIL
                    </Link> */}
                    <LinkBtn btnClass="btn btn-primary active m-3" url="/apps/inmueble/" desc="SALIR" />
                  </div>
                </div>
              </div>
            </div>
            <Modal
              show={modalShow}
              onHide={() => setModalShow(false)}
              onClick={() => setModalShow(false)}
              animation={false}
            >
              <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                  <div className="card-body text-center recycle">
                    <div className="d-inline-flex">
                      <Recycle /> <span style={{ margin: 'auto' }}>Para pagar online escanea el código QR</span>
                    </div>
                  </div>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <QRCodeSVG value={qrLink} className='img-qr' />
              </Modal.Body>
            </Modal>
          </>
        ) : error && <Error msg='Error al generar recibo. Revise la informacion e intente nuevamente' />}
      </div>
    </div>
  )
}

export default MostrarRecibo